var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '../utils/styled-components';
import { ComponentThemeProvider } from '../ThemeProvider';
import panelTheme from './theme';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: ", ";\n  background: ", ";\n"], ["\n  padding: ", ";\n  background: ", ";\n"])), function (_a) {
    var component = _a.theme.component;
    return component.panel.padding;
}, function (_a) {
    var component = _a.theme.component;
    return component.panel.background;
});
/**
 * Panel component
 */
export var Panel = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(ComponentThemeProvider, { theme: panelTheme },
        React.createElement(Wrapper, { className: className }, children)));
};
export default Panel;
var templateObject_1;
//# sourceMappingURL=index.js.map